import { authService } from './authService';
import { CORE_API_URL as API_URL } from '../config';

/**
 * Submit a support request. The API sends an email to the support team with
 * user id, tenant id, and the message. The recipient email is not exposed to the client.
 *
 * On the Go core API (cmd/api/contact.go) since slice A8. The identity in the
 * email comes from the bearer token, never from this body — which is why the
 * only thing sent is the message itself.
 */
export async function submitSupportRequest(message) {
  const token = authService.requireToken();

  const response = await fetch(`${API_URL}/api/support`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ message }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to send support request');
  }

  return response.json();
}

export const supportService = {
  submitSupportRequest,
};
